import { RouterModule, Routes } from '@angular/router';
import { EnumCodigosTwTcAcciones } from '../../_importacion/solicitudes/types/enum';
import { NgModule } from '@angular/core';
import { ActionGuard, LoginGuard } from '../../core/_infrastructure/classes/guards/main.guard';
import { UnidadInspeccionWrapperComponent } from './datos-basicos/unidad-inspeccion-wrapper/unidad-inspeccion-wrapper.component';
import { ActionEstadoUdInspeccionGuard } from '../../core/_infrastructure/classes/guards/unidades-inspeccion.guard';
import { SelectorUnidadInspeccionWrapperComponent } from './selector/selector-unidad-inspeccion-wrapper/selector-unidad-inspeccion-wrapper.component';
import { InspeccionUiWrapperComponent } from './inspecciones/inspeccion-ui-wrapper/inspeccion-ui-wrapper.component';
import { DocumentoUiWrapperComponent } from './documentos/documento-ui-wrapper/documento-ui-wrapper.component';
import { DocumentoUiWrapperEditComponent } from './documentos/documento-ui-wrapper-edit/documento-ui-wrapper-edit.component';
import { ComentarioUiWrapperComponent } from './comentarios/comentario-ui-wrapper/comentario-ui-wrapper.component';
import { ComentarioUiWrapperEditComponent } from './comentarios/comentario-ui-wrapper-edit/comentario-ui-wrapper-edit.component';
import { InspeccionUiAforoCorteWrapperEditComponent } from './aforos-y-cortes/inspeccion-ui-aforo-corte-wrapper-edit/inspeccion-ui-aforo-corte-wrapper-edit.component';
import { InspeccionUiAforoCorteWrapperComponent } from './aforos-y-cortes/inspeccion-ui-aforo-corte-wrapper/inspeccion-ui-aforo-corte-wrapper.component';
import { InspeccionUiWrapperEditComponent } from './inspecciones/inspeccion-ui-wrapper-edit/inspeccion-ui-wrapper-edit.component';

const unidadesInspeccionRoutes: Routes = [
    {
        path: 'campanias/unidadinspeccion/datosbasicos',
        data: {
            breadcrumb: 'Uds. Inspección',
            menu0: 'Campañas',
            actionCode: EnumCodigosTwTcAcciones.MENU_DATOS_BAS_UD_INSPECCION,
        },
        children: [
            {
                path: 'detail/:idUi',
                component: UnidadInspeccionWrapperComponent,
                canActivate: [LoginGuard(), ActionEstadoUdInspeccionGuard()],
                data: {
                    breadcrumb: 'Detalle de la Unidad de Inspección',
                    actionCode: EnumCodigosTwTcAcciones.MENU_DATOS_BAS_UD_INSPECCION,
                },
            },
            {
                path: 'create',
                component: SelectorUnidadInspeccionWrapperComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nueva Unidad de Inspección',
                    actionCode: EnumCodigosTwTcAcciones.NUEVA_UD_INSPECCION,
                },
            },
            {
                path: 'edition/:idUi',
                component: SelectorUnidadInspeccionWrapperComponent,
                canActivate: [LoginGuard(), ActionEstadoUdInspeccionGuard()],
                data: {
                    breadcrumb: 'Editar Unidad de Inspección',
                    actionCode: EnumCodigosTwTcAcciones.EDIT_UD_INSPECCION,
                },
            },
        ],
    },
    {
        path: 'campanias/unidadinspeccion/inspecciones',
        data: {
            breadcrumb: 'Uds. Inspección',
            menu0: 'Campañas',
            actionCode: EnumCodigosTwTcAcciones.MENU_INSPECCIONES_UI,
        },
        children: [
            {
                path: ':idUi',
                component: InspeccionUiWrapperComponent,
                canActivate: [LoginGuard(), ActionEstadoUdInspeccionGuard()],
                data: {
                    breadcrumb: 'Inspecciones de la U.I.',
                    actionCode: EnumCodigosTwTcAcciones.MENU_INSPECCIONES_UI,
                },
            },
            {
                path: ':idUi/create',
                component: InspeccionUiWrapperEditComponent,
                canActivate: [LoginGuard(), ActionEstadoUdInspeccionGuard()],
                data: {
                    breadcrumb: 'Nueva Inspección de la U.I.',
                    actionCode: EnumCodigosTwTcAcciones.ADD_INSPECCION_UI,
                },
            },
            {
                path: ':idUi/edition/:id',
                component: InspeccionUiWrapperEditComponent,
                canActivate: [LoginGuard(), ActionEstadoUdInspeccionGuard()],
                data: {
                    breadcrumb: 'Inspección de la U.I.',
                    actionCode: EnumCodigosTwTcAcciones.EDIT_INSPECCION_UI,
                },
            },
            {
                path: ':idUi/detail/:id',
                component: InspeccionUiWrapperEditComponent,
                canActivate: [LoginGuard(), ActionEstadoUdInspeccionGuard()],
                data: {
                    breadcrumb: 'Detalle de la Inspección de la U.I.',
                    actionCode: EnumCodigosTwTcAcciones.CONS_INSPECCION_UI,
                },
            },
        ],
    },
    {
        path: 'campanias/unidadinspeccion/documentos',
        data: {
            breadcrumb: 'Uds. Inspección',
            menu0: 'Campañas',
            actionCode: EnumCodigosTwTcAcciones.MENU_DOCUMENTOS_UI,
        },
        children: [
            {
                path: ':idUi',
                component: DocumentoUiWrapperComponent,
                canActivate: [LoginGuard(), ActionEstadoUdInspeccionGuard()],
                data: {
                    breadcrumb: 'Documentos de la U.I.',
                    actionCode: EnumCodigosTwTcAcciones.MENU_DOCUMENTOS_UI,
                },
            },
            {
                path: ':idUi/create',
                component: DocumentoUiWrapperEditComponent,
                canActivate: [LoginGuard(), ActionEstadoUdInspeccionGuard()],
                data: {
                    breadcrumb: 'Nuevo Documento de la U.I.',
                    actionCode: EnumCodigosTwTcAcciones.ADD_DOC_UI,
                },
            },
            {
                path: ':idUi/detail/:id',
                component: DocumentoUiWrapperEditComponent,
                canActivate: [LoginGuard(), ActionEstadoUdInspeccionGuard()],
                data: {
                    breadcrumb: 'Detalle del Documento de la U.I.',
                    actionCode: EnumCodigosTwTcAcciones.CONS_DOC_UI,
                },
            },
        ],
    },
    {
        path: 'campanias/unidadinspeccion/comentarios',
        data: {
            breadcrumb: 'Uds. Inspección',
            menu0: 'Campañas',
            actionCode: EnumCodigosTwTcAcciones.MENU_COMENTARIOS_UI,
        },
        children: [
            {
                path: ':idUi',
                component: ComentarioUiWrapperComponent,
                canActivate: [LoginGuard(), ActionEstadoUdInspeccionGuard()],
                data: {
                    breadcrumb: 'Comentarios de la U.I.',
                    actionCode: EnumCodigosTwTcAcciones.MENU_COMENTARIOS_UI,
                },
            },
            {
                path: ':idUi/create',
                component: ComentarioUiWrapperEditComponent,
                canActivate: [LoginGuard(), ActionEstadoUdInspeccionGuard()],
                data: {
                    breadcrumb: 'Nuevo Comentario de la U.I.',
                    actionCode: EnumCodigosTwTcAcciones.ADD_COMENTARIO_UI,
                },
            },
            /*
            // Actualmente sin uso. Se deja para un futuro uso
            {
                path: ':idUi/detail/:id',
                component: ComentarioUiWrapperEditComponent,
                canActivate: [LoginGuard(), ActionEstadoUdInspeccionGuard()],
                data: {
                    breadcrumb: 'Detalle del Comentario de la U.I.',
                    actionCode: EnumCodigosTwTcAcciones.CONS_COMENTARIO_UI,
                },
            },
            */
        ],
    },
    {
        path: 'campanias/unidadinspeccion/aforosycortes',
        data: {
            breadcrumb: 'Uds. Inspección',
            menu0: 'Campañas',
            actionCode: EnumCodigosTwTcAcciones.MENU_AFOROS_Y_CORTES_UI,
        },
        children: [
            {
                path: ':idUi',
                component: InspeccionUiAforoCorteWrapperComponent,
                canActivate: [LoginGuard(), ActionEstadoUdInspeccionGuard()],
                data: {
                    breadcrumb: 'Cortes/Autorización Kgs. de la U.I.',
                    actionCode: EnumCodigosTwTcAcciones.MENU_AFOROS_Y_CORTES_UI,
                },
            },
            {
                path: ':idUi/create',
                component: InspeccionUiAforoCorteWrapperEditComponent,
                canActivate: [LoginGuard(), ActionEstadoUdInspeccionGuard()],
                data: {
                    breadcrumb: 'Nuevo Corte/Autorización Kgs. de la U.I.',
                    actionCode: EnumCodigosTwTcAcciones.ADD_CORTE_UI,
                },
            },
            {
                path: ':idUi/detail/:id',
                component: InspeccionUiAforoCorteWrapperEditComponent,
                canActivate: [LoginGuard(), ActionEstadoUdInspeccionGuard()],
                data: {
                    breadcrumb: 'Detalle del Aforo y Corte de la U.I.',
                    actionCode: EnumCodigosTwTcAcciones.CONS_CORTE_UI,
                },
            },
        ],
    },
];
@NgModule({
    imports: [RouterModule.forChild(unidadesInspeccionRoutes)],
    exports: [RouterModule],
})
export class UnidadesInspeccionRoutingModule {}
